import { LoginType } from "../../../../models";

interface IEIdActionItemProps {
  loading: boolean;
  isValid?: boolean;
  actionType: LoginType;
  className: string;
  onClick: (actionType: LoginType) => void;
}

export function EIdActionItem(props: Readonly<IEIdActionItemProps>) {
  const { loading, className, onClick, actionType, isValid } = props;

  return (
    <input
      type="image"
      disabled={loading || isValid === false}
      className={className}
      src={actionType === "sc_plugin" ? "/eID.png" : "/eMobile.png"}
      alt={actionType === "sc_plugin" ? "eID" : "eMobile"}
      onClick={() => onClick(actionType)}
    />
  );
}
